// Adds `Object.values` support for IE 11.

if (!Object.values) {
	Object.values = function (obj) {
		return Object.keys(obj).map(function(item) {
			return obj[item];
		});
	};
}